export const NOT_FOUND_MESSAGE = (reason) => {
  return {
    title: "Something went wrong!",
    description:
      "We can't find the page you're looking for. You can either go back to where you were or proceed to one of the pages below.",
  };
};
